"use client";

import React, { useEffect, useState } from "react";

export interface AdminBottomActionBarProps {
  children: React.ReactNode;
  className?: string;
}

const visibleMobileBottomOffset = "bottom-[calc(5.75rem+env(safe-area-inset-bottom))]";
const hiddenMobileBottomOffset = "bottom-[calc(0.75rem+env(safe-area-inset-bottom))]";

function isAdminBottomNavHidden() {
  if (typeof document === "undefined") return false;
  return document.body.dataset.adminBottomNav === "hidden";
}

export function AdminBottomActionBar({
  children,
  className = "",
}: AdminBottomActionBarProps) {
  const [mobileNavHidden, setMobileNavHidden] = useState(isAdminBottomNavHidden);

  useEffect(() => {
    const syncWithAdminLayout = () => {
      setMobileNavHidden(isAdminBottomNavHidden());
    };

    syncWithAdminLayout();
    window.addEventListener("admin:bottom-nav-visibility", syncWithAdminLayout);

    return () => {
      window.removeEventListener("admin:bottom-nav-visibility", syncWithAdminLayout);
    };
  }, []);

  return (
    <div
      className={`pointer-events-none fixed inset-x-0 ${
        mobileNavHidden ? hiddenMobileBottomOffset : visibleMobileBottomOffset
      } z-20 px-3 transition-[bottom] duration-300 ease-out md:static md:mt-5 md:flex md:justify-center md:px-0 ${className}`
        .trim()
        .replace(/\s+/g, " ")}
    >
      <div className="pointer-events-auto mx-auto w-full max-w-sm bg-transparent p-0 md:w-fit md:max-w-md">
        <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-center">
          {children}
        </div>
      </div>
    </div>
  );
}
